<template>
  <div class="request-design-modal">
    <v-dialog
      v-bind="{...$props, ...$attrs}"
      v-on="$listeners"
      max-width="1000"
      :fullscreen="isMobileBreakpoint"
      width="100%">
      <v-card height="500" class="d-flex" :class="[{ 'flex-column': isMobileBreakpoint }]">
        <v-slide-y-reverse-transition>
          <div v-if="!isMobileBreakpoint || (isMobileBreakpoint && step === 1)" class="first-half d-flex flex-column justify-space-between" :class="[{ 'tw-w-full': isMobileBreakpoint }]">
            <div>
              <v-btn icon @click="$emit('input', false)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <svg width="329" height="350" viewBox="0 0 329 350" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_2842_15926)">
                <path d="M42.5533 139.474V369.285H265.959V139.474L281.791 182.572L349.516 149.707L289.796 46.3037C289.112 45.1182 288.081 44.1702 286.843 43.5866L208.15 6.50608C207.254 6.08407 206.277 5.86523 205.287 5.86523H108.792C107.874 5.86523 106.966 6.05329 106.124 6.4178L20.3797 43.5255C18.9496 44.1444 17.7792 45.2413 17.0688 46.6282L-35.7275 149.707L24.0825 182.572L42.5533 139.474Z" fill="white"/>
                <path d="M42.5533 369.285H40.8739V370.964H42.5533V369.285ZM42.5533 139.474H44.2327L41.0097 138.813L42.5533 139.474ZM24.0825 182.572L23.2737 184.044L24.8967 184.936L25.6261 183.234L24.0825 182.572ZM-35.7275 149.707L-37.2223 148.942L-37.9659 150.394L-36.5363 151.179L-35.7275 149.707ZM17.0688 46.6282L18.5636 47.3938L17.0688 46.6282ZM20.3797 43.5255L19.7127 41.9843L20.3797 43.5255ZM106.124 6.4178L106.791 7.95906V7.95906L106.124 6.4178ZM208.15 6.50608L208.866 4.98688V4.98688L208.15 6.50608ZM286.843 43.5866L287.558 42.0674L286.843 43.5866ZM289.796 46.3037L291.251 45.4638V45.4638L289.796 46.3037ZM349.516 149.707L350.249 151.218L351.873 150.43L350.97 148.867L349.516 149.707ZM281.791 182.572L280.214 183.151L280.854 184.893L282.524 184.083L281.791 182.572ZM265.959 139.474L267.535 138.895L264.279 139.474H265.959ZM265.959 369.285V370.964H267.638V369.285H265.959ZM44.2327 369.285V139.474H40.8739V369.285H44.2327ZM41.0097 138.813L22.5389 181.911L25.6261 183.234L44.0969 140.136L41.0097 138.813ZM24.8913 181.1L-34.9188 148.235L-36.5363 151.179L23.2737 184.044L24.8913 181.1ZM-34.2328 150.473L18.5636 47.3938L15.5741 45.8626L-37.2223 148.942L-34.2328 150.473ZM21.0468 45.0668L106.791 7.95906L105.457 4.87654L19.7127 41.9843L21.0468 45.0668ZM108.792 7.54464H205.287V4.18583H108.792V7.54464ZM207.434 8.02527L286.127 45.1058L287.558 42.0674L208.866 4.98688L207.434 8.02527ZM288.342 47.1436L348.062 150.547L350.97 148.867L291.251 45.4638L288.342 47.1436ZM348.783 148.196L281.058 181.061L282.524 184.083L350.249 151.218L348.783 148.196ZM283.367 181.993L267.535 138.895L264.382 140.053L280.214 183.151L283.367 181.993ZM264.279 139.474V369.285H267.638V139.474H264.279ZM265.959 367.605H42.5533V370.964H265.959V367.605ZM286.127 45.1058C287.055 45.5435 287.828 46.2545 288.342 47.1437L291.251 45.4638C290.395 43.9819 289.106 42.7969 287.558 42.0674L286.127 45.1058ZM205.287 7.54464C206.029 7.54464 206.762 7.70876 207.434 8.02527L208.866 4.98688C207.746 4.45937 206.524 4.18583 205.287 4.18583V7.54464ZM106.791 7.95906C107.423 7.68568 108.104 7.54464 108.792 7.54464V4.18583C107.645 4.18583 106.51 4.4209 105.457 4.87654L106.791 7.95906ZM18.5636 47.3938C19.0964 46.3536 19.9742 45.531 21.0468 45.0668L19.7127 41.9843C17.9251 42.7579 16.4621 44.1289 15.5741 45.8626L18.5636 47.3938Z" fill="#514A41"/>
                <mask id="path-3-inside-1_2842_15926" fill="white">
                  <path d="M206.106 13.8608H110.035C107.722 13.8608 106.469 16.57 107.954 18.3431C134.079 49.528 182.158 49.5771 208.195 18.3192C209.67 16.5485 208.411 13.8608 206.106 13.8608Z"/>
                </mask>
                <path d="M208.195 18.3192L205.614 16.1695V16.1695L208.195 18.3192ZM107.954 18.3431L105.379 20.5H105.379L107.954 18.3431ZM110.035 17.2196H206.106V10.502H110.035V17.2196ZM205.614 16.1695C180.925 45.8098 135.316 45.7741 110.529 16.1861L105.379 20.5C132.842 53.282 183.391 53.3444 210.776 20.469L205.614 16.1695ZM206.106 17.2196C205.564 17.2196 205.267 16.5866 205.614 16.1695L210.776 20.469C214.073 16.5104 211.258 10.502 206.106 10.502V17.2196ZM110.035 10.502C104.843 10.502 102.08 16.5619 105.379 20.5L110.529 16.1861C110.59 16.2593 110.65 16.3831 110.666 16.5283C110.68 16.6585 110.656 16.7671 110.617 16.8499C110.579 16.9328 110.511 17.0245 110.398 17.1004C110.272 17.1851 110.133 17.2196 110.035 17.2196V10.502Z" fill="#514A41" mask="url(#path-3-inside-1_2842_15926)"/>
                <path d="M39.2275 120.495L42.5863 129.582V140.331" stroke="#514A41" stroke-width="3.35881"/>
                <path d="M269.149 120.495L265.791 129.582V140.331" stroke="#514A41" stroke-width="3.35881"/>
                <path d="M69.291 86.5758L235.975 270.34" stroke="#514A41" stroke-width="3.35881"/>
                <path d="M235.975 86.5758L69.2906 270.34" stroke="#514A41" stroke-width="3.35881"/>
                <rect x="69.5534" y="85.8991" width="166.859" height="183.94" stroke="#514A41" stroke-width="3.35881"/>
                <rect x="65.7566" y="82.2777" width="6.71761" height="6.71761" fill="white" stroke="#514A41" stroke-width="3.35881"/>
                <rect x="65.7566" y="266.48" width="6.71761" height="6.71761" fill="white" stroke="#514A41" stroke-width="3.35881"/>
                <rect x="232.408" y="82.2777" width="6.71761" height="6.71761" fill="white" stroke="#514A41" stroke-width="3.35881"/>
                <rect x="232.408" y="266.48" width="6.71761" height="6.71761" fill="white" stroke="#514A41" stroke-width="3.35881"/>
              </g>
              <defs>
                <clipPath id="clip0_2842_15926">
                  <rect width="384.583" height="349.316" fill="white" transform="translate(-35.7275 0.68103)"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </v-slide-y-reverse-transition>
        <div class="content-half flex-grow-1 pa-2">
          <div v-if="isMobileBreakpoint && step > 1">
            <v-btn icon @click="$emit('input', false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <component :is="comp" @next="step++" @update="onRequestDataUpdate" :step="step" />
          <div class="d-flex btns-action mx-auto" v-if="step > 1">
            <v-btn depressed height="42" @click="step--" rounded>Back</v-btn>
            <v-btn class="flex-grow-1 ml-2" @click="moveNext" depressed rounded height="42" color="primary">Next</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RequestDesignStepOne from "@/components/build/request_design/RequestDesignStepOne"
import RequestDesignFillDetails from "@/components/build/request_design/RequestDesignFillDetails"
import image from "@/assets/shirts/small_sample_shirt.svg";
import { uploadDocumentToCloudinary } from "@/services/helpers";
export default {
  name: "RequestDesignModal",
  components: {
    RequestDesignStepOne,
    RequestDesignFillDetails
  },
  data: () => ({
    // dialog: false,
    step: 1,
    requestData: {
      merch_name: '',
      text: '',
      selected_product: null,
      design_print: null
    }
  }),
  computed: {
    comp () {
      if (this.step === 1) {
        return 'request-design-step-one'
      }
      return 'RequestDesignFillDetails'
    },
    isMobileBreakpoint () {
      const mobile = this.$vuetify.breakpoint.width <= 767
      return mobile
    }
  },
  methods: {
    moveNext () {
      if (this.step === 2) {
        if (!this.requestData.text) return this.$displaySnackbar({message: "No design prints"})
        this.step++
      } else if (this.step === 3) {
        if (!this.requestData.merch_name || !this.requestData.selected_product)
          return this.$displaySnackbar({message: "Please fill empty fields"})
        this.$store.commit('buildMerch/SET_REQUEST_DESIGN', this.requestData)
        this.$router.push({ name: 'AddToCart', query: { productName: this.requestData.selected_product.name, title: this.requestData.merch_name, request: '1' } })
      }
    },
    onRequestDataUpdate ({ label, value }) {
      // const { url } = await uploadDocumentToCloudinary(file, 'requested_design_images')
      console.log({ label, value })
      this.requestData[label] = value
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .first-half {
    background: #F9F4EE;
    height: 100%;

    &:not(.tw-w-full) {
      width: 328px;
    }

    &.tw-w-full {
      svg {
        width: 100%;
        height: 80%;
      }
    }
  }

  .content-half {}

  .btns-action {
    max-width: 335px;
  }
}
</style>
